<template>
  <div class="app-header" :class="{ showList: isShow}">
    <div class="top-box" :class="{ 'showTop': isShow}">
      <img class="ms-logo" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/logo-ms.png">
      <div class="icon-menu-box" :class="{ 'content-show': isShow }" @click="isShow = !isShow">
        <!-- <img v-if="isShow" class="menu-icon" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-close.png">
        <img v-else class="menu-icon" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-menu.png"> -->
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </div>
    </div>
    <div class="menu-list-box" :class="{'slideIn': isShow }">
      <div class="menu-box">
        <nav-item :openType="openType" v-for="(item, index) in navList" :key="index" :vm="item" @changeOpen="changeOpen" @close="closeHeader"></nav-item>
      </div>
    </div>
  </div>
</template>
<script>
import { navList } from '@/const/index'
import navItem from './components/navItem'
export default {
  data () {
    return {
      isShow: false,
      navList: navList,
      isFirst: true,
      openType: 0
    }
  },
  mounted (){
    this.$nextTick(() => {
      this.isFirst = false
    })
  },
  components: { navItem },
  methods: {
    changeOpen (type) {
      this.openType = type || 0
    },
    closeHeader () {
      this.isShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header{
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 999;
  .top-box{
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 30px 0px 14px;
    position: absolute;
    top: 0px;
    width: 100%;
    left: 0px;
    z-index: 1000;
    background: #ffffff;
    border-bottom: 1px solid #ffffff;
    .ms-logo{
      width: 107px;
      height: 16px;
    }
    .icon-menu-box{
      width: 18px;
      height: 17px;
      .line{
        display: block;
        height: 3px;
        box-sizing: border-box;
        border: none;
        width: 20px;
        background: #424242;
        margin-bottom: 4px;
        border-radius: 4px;
        &:last-of-type{
          margin-bottom: 0px;
        }
        transition:  0.3s;
      }
      &.content-show{
        transform: rotate(45deg);
        .line1{
          // width: 24px;
          transform: translateY(7px);
          transform-origin: 50% 50%;
        }
        .line2{
          opacity: 0;
        }
        .line3{
          // width: 24px;
          transform: translateY(-7px) rotate(-90deg); 
          transform-origin: 50% 50%;
        }
      }
    }
    &.showTop{
      border-bottom: 1px solid #F1F1F1;
    }
  }
  .menu-list-box{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    overflow: scroll;
    background: #ffffff;
    z-index: 999;
    transform: translateY(-100%);
    transition: all 0.3s;
    .menu-box{
      padding: 40px 30px 0px;
      text-align: left;
    }
    &::-webkit-scrollbar{
      display: none;
    }
    &.slideIn {
      transform: translateY(0%);
    }
  }
}
</style>